export const LIFECYCLE_EVENTS_QUERY_KEY = 'lifecycle-events'
